import { render } from "./userListSidebar.vue?vue&type=template&id=d43aaad8"
import script from "./userListSidebar.vue?vue&type=script&lang=js"
export * from "./userListSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__